
import { AppState } from '../types';
import { getTodayDateString } from '../utils/date';

export const CURRENT_VERSION = '2.0.0';

/**
 * Migrates older data structures to the current AppState format.
 * This function is designed to be extended with new migration steps as the app evolves.
 * @param data The loaded data, which could be from an older version.
 * @returns An AppState object conforming to the latest version.
 */
export const migrate = (data: any): AppState => {
  let migratedData = { ...data };

  // Migration from an un-versioned state to v2.0.0
  if (!migratedData.version) {
    console.log("Migrating data to v2.0.0");
    
    migratedData.version = CURRENT_VERSION;
    
    // Initialize saveDownloadedToday. If the save is from today, it's false.
    // If it's from a previous day, we can consider it true to not block the user.
    migratedData.saveDownloadedToday = data.date === getTodayDateString() ? false : true;
  }
  
  // Future migration steps can be chained here, e.g.:
  // if (migratedData.version < '2.1.0') {
  //   migratedData = migrateToV2_1(migratedData);
  // }

  return migratedData as AppState;
};
